import { useForceUpdate, useIsomorphicLayoutEffect } from '../helpers';
import { useRef } from 'react';
var getObserver = function (args) {
    return typeof args[1] === 'function' || args[1] === null || args[1] === undefined
        ? {
            next: args[1],
            error: args[2],
            complete: args[3]
        }
        : args[1];
};
/**
 *
 * @template TInput Input value within Observable.
 *
 * @param useCustomEffect useEffect or useLayoutEffect
 * @param args collected arguments
 */
export function useSubscriptionInternal(useCustomEffect, args) {
    var forceUpdate = useForceUpdate();
    var argsRef = useRef(args);
    var errorRef = useRef();
    var subscriptionRef = useRef();
    // Update the latest observable and callbacks
    // synchronously after render being committed
    useIsomorphicLayoutEffect(function () {
        argsRef.current = args;
    });
    useCustomEffect(function () {
        errorRef.current = null;
        // keep in closure for checking staleness
        var input$ = argsRef.current[0];
        var subscription = input$.subscribe({
            next: function (value) {
                if (input$ !== argsRef.current[0]) {
                    // stale observable
                    return;
                }
                var observer = getObserver(argsRef.current);
                if (observer.next) {
                    return observer.next(value);
                }
            },
            error: function (error) {
                if (input$ !== argsRef.current[0]) {
                    // stale observable
                    return;
                }
                var observer = getObserver(argsRef.current);
                if (observer.error) {
                    errorRef.current = null;
                    return observer.error(error);
                }
                errorRef.current = error;
                forceUpdate();
            },
            complete: function () {
                if (input$ !== argsRef.current[0]) {
                    // stale observable
                    return;
                }
                var observer = getObserver(argsRef.current);
                if (observer.complete) {
                    return observer.complete();
                }
            }
        });
        subscriptionRef.current = subscription;
        return function () {
            subscription.unsubscribe();
        };
    }, [args[0]]);
    if (errorRef.current) {
        // Let error boundary catch the error
        throw errorRef.current;
    }
    return subscriptionRef;
}
//# sourceMappingURL=use-subscription-internal.js.map